import React from 'react';
import classNames from 'classnames';
import { Currency } from '../../../ui-toolkit';
import { eFeePropertyNames } from '../../../types/order/fees/eFeePropertyNames';
import { camelCaseToTitleCase } from '../../../utilities/shared/stringMethods/stringMethods';
import { eTransactionCategory } from '../../../ui-toolkit/enums/eTransactionType';

interface ISectionHeaderTotalsProps {
  feeSectionTotals?: { [key: string]: number };
  transactionCategory: eTransactionCategory;
}
export const SectionHeaderTotals: React.FC<ISectionHeaderTotalsProps> = ({ feeSectionTotals, transactionCategory }) => {
  const feeProperties =
    transactionCategory === eTransactionCategory.Purchase
      ? [eFeePropertyNames.BuyerPaid, eFeePropertyNames.SellerPaid, eFeePropertyNames.OthersPaid]
      : [eFeePropertyNames.BuyerPaid, eFeePropertyNames.OthersPaid];
  //backend uses naming buyerPaid property rather than borrowerPaid for totals in refinance orders
  return (
    <div className={'flex'}>
      <div className={'justify-self-end whitespace-nowrap p-4 pr-8 pt-10'}>Totals</div>
      {feeProperties.map((fee) => {
        return (
          <div className={classNames(`col-span-2 grid p-4`)} key={fee}>
            <div className={'justify-self-end whitespace-nowrap font-bold'}>
              {transactionCategory === eTransactionCategory.Refinance && fee === eFeePropertyNames.BuyerPaid
                ? 'Borrower Paid'
                : camelCaseToTitleCase(fee)}
            </div>

            <div className={'justify-self-end text-base font-medium'}>
              <Currency
                data-test-id={'section-totals'}
                value={feeSectionTotals && feeSectionTotals[fee] ? feeSectionTotals[fee] : 0}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
